import gql from 'graphql-tag';

const UserTransactionFragment = gql`
  fragment UserTransaction on paymentDataForAdmin {
    id
    confirmationCode
    transactionReference
    referenceNumber
    userName
    type
    status
    processStatus
    emailStatus
    invoiceReceivedStatus
    totalAmount
    # totalAmountEuro
    shop
    createdAt
    thirdPartyAPIBuyResponse
    thirdPartyAPIInvoiceResponse
    actionStatus
  }
`;

export const GetUserTransactionsQuery = gql`
  query GetUserTransactions(
    $filter: getPaymentsFilterInput
    $order: getPaymentsSortFilterInput
    $skip: Int
    $take: Int
  ) {
    getPayments(filter: $filter, order: $order, skip: $skip, take: $take) {
      payments {
        ...UserTransaction
      }
      totalCount
      queryCount
    }
  }
  ${UserTransactionFragment}
`;

export const GetSingleUserTransactionQuery = gql`
  query GetSingleUserTransaction($filter: getPaymentsFilterInput) {
    getPayments(filter: $filter, take: 1) {
      payments {
        ...UserTransaction
        userId
        items
        documents
        payload
        paymentProcessor
        transactionReferenceId
        emailId
      }
    }
  }
  ${UserTransactionFragment}
`;
